// Summary cards for the admin store pages (/store-products/:id, /store-users/:id, ...).
// Same cards the store owner sees on their own page, but across every branch of the
// chosen store (GET admin_store_summary/{store}/{type}).
//
// Usage: mixins: [adminStoreSummary], then `await this.fetchSummary("categories")`
// and render <KpiCards :items="kpiItems" :loading="loadingSummary" />.
// A page can override `kpiExtra(item, index)` to add per-card fields (e.g. a breakdown).
export const adminStoreSummary = {
  data: () => ({
    summaries: [],
    loadingSummary: false,
  }),
  computed: {
    kpiItems() {
      return (this.summaries || []).map((item, index) => ({
        key: index,
        title: item.title,
        icon: item.icon,
        value: item.total ?? 0,
        note: item.description ? this.$t(item.description) : "",
        ...(typeof this.kpiExtra === "function" ? this.kpiExtra(item, index) : {}),
      }));
    },
  },
  methods: {
    async fetchSummary(type) {
      const { store_id } = this.$route.params;
      this.loadingSummary = true;
      try {
        const { data } = await this.$http.get(
          `admin_store_summary/${store_id}/${type}`,
        );
        if (data.status) this.summaries = data.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingSummary = false;
      }
    },
  },
};
